import { memo, useState } from 'react';
import { FormCheck } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

import type { CommonInputProps } from '../InputsTypes';
import '../inputs.scss';
import './inputSwitch.scss';

interface Props extends CommonInputProps {
  defaultValue?: boolean;
  link?: string;
  hookOnChange?: (value: boolean) => void;
  onInputChange?: (value: boolean) => void;
}

const InputSwitch = ({
  name,
  label,
  defaultValue,
  disabled = false,
  required = false,
  design = 'col-12',
  hookError,
  hookOnChange = () => {},
  onInputChange = () => {}
}: Props) => {
  const { t } = useTranslation();
  const [value, setValue] = useState<boolean>(defaultValue!);

  return (
    <div className={`${design} input_switch`}>
      <FormCheck
        required={required}
        disabled={disabled}
        name={name}
        defaultChecked={defaultValue}
        label={label && t(label)}
        type="switch"
        id="custom-switch"
        onChange={() => {
          setValue(!value);
          hookOnChange(!value);
          onInputChange(!value);
        }}
      />
      {hookError?.message && (
        <p className="customInput_error">{t(hookError?.message)}</p>
      )}
    </div>
  );
};

const MemoizeSwitch = memo(InputSwitch);
export default MemoizeSwitch;
